import { getFocusables } from '../lib-getFocusables';
/**
 * When modals open they focus first focusable element inside
 * If selector is provided, try to focus it
 * Then try to focus the first control element
 * If no control elements, then the first focusable
 * If no focusables, then the element itself
 */
export function focusFirstAvailable(el, selector) {
    var fromSelector = querySelectorHtml(el, selector)[0];
    var focusables = getFocusables(el);
    var control = focusables.find(function (e) { return ['input', 'select', 'textarea'].includes(e.tagName.toLowerCase()); });
    var firstFocusable = focusables[0];
    var toFocus = [fromSelector, control, firstFocusable, el].find(function (e) { return !!e; });
    toFocus.focus();
}
function querySelectorHtml(el, selector) {
    if (selector) {
        return Array.from(el.querySelectorAll(selector));
    }
    else {
        return [];
    }
}
